import store from "@/store";

const routes = [{
    path: "/operations/wpf/:id",
    name: "warehousewpf",
    component: () => import('@/views/main/modules/Operations/WPF/WarehousePreparationGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'WPF',
    }
}]

export default routes;
